<template>
  <v-expansion-panels
    class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>Tìm kiếm sản phẩm</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
          class="ma-0"
          outlined
        >
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="filterForm.keyword"
                    label="Tìm kiếm theo sản phẩm, mã sản phẩm"
                    placeholder="Tên sản phẩm, mã...."
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="filterForm.groupId"
                    :items="groupIds"
                    item-text="name"
                    item-value="id"
                    label="Tìm kiếm theo nhóm sản phẩm"
                    placeholder="Nhóm sản phẩm"
                    color="primary"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="6"
                       :class="checkAuthorization('order-ctv-create_read') && !checkAuthorization('contact_read') ? 'hiden-filter-siteId' : ''">
                  <v-autocomplete
                      v-model="filterForm.siteId"
                      :items="sites"
                      item-text="name"
                      item-value="id"
                      label="Tìm kiếm theo công ty"
                      placeholder="Công ty"
                      color="primary"
                      clearable
                      multiple
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn
                  class="primary mx-0"
                  @click="searchReport"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>

            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>

import { formatDate } from '@/helpers/utils'
import * as moment from 'moment'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const ProductGroupRepository = RepositoryFactory.get('product_group')
const SiteRepository = RepositoryFactory.get('site')

export default {
  props: {
    filterForm: {
      default: () => ({}),
    },
  },
  data () {
    return {
      defaultRange: {
        startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
      },
      groupIds: [],
      sites: []
    }
  },
  created() {
    this.fetchdDataProductGroup();
    if(this.checkAuthorization('order-ctv-create_read') && !this.checkAuthorization('contact_read')) {
      // this.getSites();
    } else {
      this.getSites();
    }
  },
  methods: {
    searchReport () {
      this.$emit('product-filter', this.filterForm)
    },
    async fetchdDataProductGroup () {
      const response = await ProductGroupRepository.list({limit: 1000})
      if (response.success) {
        this.groupIds = _.get(response, 'data', [])
      }
    },
    async getSites() {
      let res = await SiteRepository.list()
      if (res.success) {
        this.sites = _.get(res, 'data', [])
        this.sites.unshift({
          id: 0,
          name: 'Tất cả'
        })
      } else {
        this.sites = []
      }
    }
  },
}
</script>
<style scoped>
.hiden-filter-siteId {
  display: none;
}
</style>